/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfiguredPayor } from './ConfiguredPayor';
import {
    ConfiguredPayorFromJSON,
    ConfiguredPayorFromJSONTyped,
    ConfiguredPayorToJSON,
} from './ConfiguredPayor';

/**
 * 
 * @export
 * @interface FacilityPayorConfig
 */
export interface FacilityPayorConfig {
    /**
     * The facility ID
     * @type {string}
     * @memberof FacilityPayorConfig
     */
    facility_id?: string;
    /**
     * 
     * @type {Array<ConfiguredPayor>}
     * @memberof FacilityPayorConfig
     */
    configured_payors?: Array<ConfiguredPayor>;
}

/**
 * Check if a given object implements the FacilityPayorConfig interface.
 */
export function instanceOfFacilityPayorConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FacilityPayorConfigFromJSON(json: any): FacilityPayorConfig {
    return FacilityPayorConfigFromJSONTyped(json, false);
}

export function FacilityPayorConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPayorConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'configured_payors': !exists(json, 'configured_payors') ? undefined : ((json['configured_payors'] as Array<any>).map(ConfiguredPayorFromJSON)),
    };
}

export function FacilityPayorConfigToJSON(value?: FacilityPayorConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'configured_payors': value.configured_payors === undefined ? undefined : ((value.configured_payors as Array<any>).map(ConfiguredPayorToJSON)),
    };
}

